// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"6a2f59e2","387":"f7ff25d9","453":"4f451148"}[chunkId] + ".chunk.js";
};